import { render } from "./ProviderLoginButton.vue?vue&type=template&id=7c2d4a6f&scoped=true"
import script from "./ProviderLoginButton.vue?vue&type=script&lang=js"
export * from "./ProviderLoginButton.vue?vue&type=script&lang=js"

import "./ProviderLoginButton.vue?vue&type=style&index=0&id=7c2d4a6f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2d4a6f"]])

export default __exports__